/**
 * Extract a readable error message from various backend payload shapes.
 * Supports strings, top-level { Message, Code }, nested response objects, and Print fields.
 * @param {any} data
 * @returns {string}
 */
function extractErrorMessage(data) {
    if (!data) return '';
    if (typeof data === 'string') return data;

    const obj = (data && typeof data.response === 'object' && data.response) ? data.response : data;

    const fromKeys =
        obj.message || obj.Message ||
        obj.response_message || obj.responseMessage ||
        obj.error || obj.Error ||
        obj.detail || obj.details;

    if (fromKeys) return String(fromKeys);

    try {
        if (obj.Print) {
            const toStr = obj.Print && typeof obj.Print.toString === 'function' ? obj.Print.toString() : String(obj.Print);
            if (toStr && toStr.includes('failed')) return toStr;
            return toStr;
        }
    } catch (_) { /* ignore */ }

    try { return JSON.stringify(obj); } catch (_) { return ''; }
}

export const errorHandler = {
    throwNotFound() {
        return 'Failed to Connect to Server! (Url not found)';
    },

    throwTimeOut() {
        return 'Connection Time Out!';
    },

    franchiseLoginError(errorResponse) {
        console.error(errorResponse)
        if (errorResponse.response.status === 404) {
            return this.throwNotFound();
        }
        return errorResponse.response.data.message;
    },

    /**
     * Normalize and display backend/Tomcat errors.
     * Detects PreparedStatement/DB errors and presents a friendly message to users.
     * @param {any} err Axios error or similar
     * @param {boolean} [isSweetalert=false] if true, do not auto-toast via responses.throwErr
     * @param {string} [title='An Error Occurred'] title for the toast/dialog
     */
    tomcatError(err, isSweetalert = false, title = 'An Error Occurred') {
        const status = err?.response?.status;
        const data = err?.response?.data;

        let message = extractErrorMessage(data);

        if (status === 404 && !message) message = this.throwNotFound();
        if (err?.code === 'ECONNABORTED') message = this.throwTimeOut();

        if (message === 'Network Error') {
            title = message;
            message = 'Please Check your Internet';
        }

        const rawForDev = message || err?.message || '';
        if (/PreparedStatement|statement is null|SQL|database/i.test(rawForDev)) {
            console.warn('[DB Error]', rawForDev);
            message = 'The server hit a database error while processing your request. Please try again.';
        }

        if (!message) message = err?.message || 'Unexpected server error.';

        if (!isSweetalert) {
            responses.throwErr(message, title);
        }
        throw new Error(message);
    },
    /**
     * Normalize backend error and return a user-facing string without side effects.
     * @param {any} err
     * @returns {string}
     */
    tomcatErrorString(err) {
        const status = err?.response?.status;
        const data = err?.response?.data;

        let message = extractErrorMessage(data);

        if (status === 404 && !message) message = this.throwNotFound();
        if (err?.code === 'ECONNABORTED') message = this.throwTimeOut();

        const rawForDev = message || err?.message || '';
        if (/PreparedStatement|statement is null|SQL|database/i.test(rawForDev)) {
            console.warn('[DB Error]', rawForDev);
            message = 'The server hit a database error while processing your request. Please try again.';
        }

        if (!message) message = err?.message || 'Unexpected server error.';
        return message;
    },

    customerKazangError(err, isSweetalert = false) {
        console.log(err)
        let response = err.response;
        let errorMessage;
        if (response) {
            console.error(response)
            if (response.status === 404) {
                errorMessage = this.throwNotFound();
            } else {
                errorMessage = response.data;
            }
        }else if (err.Error){
            errorMessage = err.Message;
        }else if (err.code === `ECONNABORTED`){
            errorMessage = this.throwTimeOut()
        }
        if (!isSweetalert) {
            responses.throwErr(errorMessage);
        }
        throw new Error(errorMessage);
    },
}